import React, { useState, useEffect } from 'react';
import {
    useNavigate,
    useLocation
} from "react-router-dom";
import PrattLogo from '../assets/images/pratt-logo.png';

const Navbar = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const user = JSON.parse(localStorage.getItem('user'));

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownOpen && !event.target.closest('.user-menu')) {
                setDropdownOpen(false);
            }
        };

        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [dropdownOpen]);

    const handleLogout = () => {
        setDropdownOpen(false);
        localStorage.removeItem('user');
        // if in /, refresh the page:
        if (location.pathname === '/') {
            window.location.reload();
        } else {
            navigate('/');
        }
    };

    const handleProfile = () => {
        setDropdownOpen(false);
        navigate('/profile');
    };

    return (
        <div style={styles.navbar}>
            <img 
                src={PrattLogo}
                alt="Home" 
                style={styles.navLogo}
                onClick={() => navigate('/')}
                onMouseOver={(e) => e.target.style.opacity = '0.8'}
                onMouseOut={(e) => e.target.style.opacity = '1'}
            />
            {user && (
                <div style={styles.userMenu} className="user-menu">
                    <div 
                        style={styles.userName}
                        onClick={() => setDropdownOpen(!dropdownOpen)}
                        onMouseOver={(e) => e.target.style.backgroundColor = '#e5e5e5'}
                        onMouseOut={(e) => e.target.style.backgroundColor = 'transparent'}
                    >
                        {user.name}
                    </div>
                    {dropdownOpen && (
                        <div style={styles.dropdownMenu}>
                            <div
                                style={{...styles.dropdownItem, ...styles.dropdownItemFirst}}
                                onClick={handleProfile}
                                onMouseOver={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                                onMouseOut={(e) => e.target.style.backgroundColor = 'white'}
                            >
                                Profile
                            </div>
                            <div
                                style={{...styles.dropdownItem, ...styles.dropdownItemLast}}
                                onClick={handleLogout}
                                onMouseOver={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                                onMouseOut={(e) => e.target.style.backgroundColor = 'white'}
                            >
                                Log Out
                            </div>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

const styles = {
    navbar: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 20px',
        height: '60px',
        backgroundColor: '#f5f5f5',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
    },
    navLogo: {
        height: '60px',
        cursor: 'pointer',
        transition: 'opacity 0.2s'
    },
    navLogoHover: {
        opacity: '0.8'
    },
    userMenu: {
        position: 'relative'
    },
    userName: {
        cursor: 'pointer',
        padding: '8px 12px',
        borderRadius: '4px',
        transition: 'background-color 0.2s'
    },
    userNameHover: {
        backgroundColor: '#e5e5e5'
    },
    dropdownMenu: {
        position: 'absolute',
        top: '100%',
        right: '0',
        backgroundColor: 'white',
        borderRadius: '4px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        minWidth: '150px',
        marginTop: '8px'
    },
    dropdownItem: {
        padding: '12px 16px',
        cursor: 'pointer',
        transition: 'background-color 0.2s'
    },
    dropdownItemHover: {
        backgroundColor: '#f5f5f5'
    },
    dropdownItemFirst: {
        borderRadius: '4px 4px 0 0'
    },
    dropdownItemLast: {
        borderRadius: '0 0 4px 4px'
    }
};

export default Navbar;